import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={58.784}
      height={101.24}
      viewBox="0 0 58.784 101.24"
      {...props}
    >
      <path
        data-name="Path 977"
        d="M14.696 83.278h6.532v16.329h-6.532z"
        fill="#165a9f"
      />
      <path
        data-name="Path 978"
        d="M34.291 83.278h9.8v16.329h-9.8z"
        fill="#165a9f"
      />
      <path
        data-name="Path 979"
        d="M8.165 73.48a6.532 6.532 0 110-13.063H50.62a6.532 6.532 0 110 13.063z"
        fill="#003586"
      />
      <path
        data-name="Path 980"
        d="M50.62 76.747a6.53 6.53 0 01-6.531 6.534H14.697a6.53 6.53 0 01-6.532-6.534v-3.266H50.62z"
        fill="#165a9f"
      />
      <path
        data-name="Path 981"
        d="M47.354 57.152v3.268H11.43v-3.268a6.53 6.53 0 016.532-6.532h22.86a6.53 6.53 0 016.532 6.532z"
        fill="#165a9f"
      />
      <path
        data-name="Path 982"
        d="M41.896 17.08a40.7 40.7 0 00-6.364-11.757l-.866-1.11a6.681 6.681 0 00-10.549 0l-.865 1.11a40.711 40.711 0 00-7.772 32.92l2.482 12.377h22.86l2.482-12.377a40.883 40.883 0 00-1.4-21.162z"
        fill="#ffe177"
      />
      <path
        data-name="Path 983"
        d="M32.658 21.228V50.62h-6.532V21.228a3.275 3.275 0 013.266-3.266 3.29 3.29 0 013.266 3.266z"
        fill="#cf1e22"
      />
      <path
        data-name="Path 984"
        d="M58.784 66.949a8.174 8.174 0 00-8.164-8.165h-1.633v-1.632a8.164 8.164 0 00-6.225-7.907L44.9 38.556a42.249 42.249 0 00-8.081-34.232l-.867-1.115a8.309 8.309 0 00-13.119 0l-.867 1.115a42.249 42.249 0 00-8.081 34.232l2.137 10.689A8.164 8.164 0 009.8 57.152v1.633H8.164a8.165 8.165 0 00-1.633 16.164v1.8a8.18 8.18 0 006.532 8v16.491h9.8V84.911h9.8v16.329h13.058V84.746a8.178 8.178 0 006.532-8v-1.8a8.18 8.18 0 006.531-7.997zM24.542 6.327l.867-1.115a5.046 5.046 0 017.964 0l.867 1.117a38.985 38.985 0 017.46 31.587l-2.217 11.071h-5.192V21.228a4.9 4.9 0 10-9.8 0v27.759H19.3l-2.213-11.073a38.99 38.99 0 017.455-31.586zm6.483 42.66h-3.266V21.228a1.633 1.633 0 113.266 0zm-17.962 8.165a4.9 4.9 0 014.9-4.9h22.859a4.9 4.9 0 014.9 4.9v1.633H13.063zm6.532 40.823h-3.266V84.911h3.266zm16.329 0V84.911h6.532v13.063zm8.164-16.329H14.7a4.9 4.9 0 01-4.9-4.9v-1.632h39.19v1.633a4.9 4.9 0 01-4.902 4.898zm6.532-9.8H8.164a4.9 4.9 0 010-9.8H50.62a4.9 4.9 0 010 9.8z"
      />
      <path data-name="Path 985" d="M6.532 65.316h3.266v3.266H6.532z" />
      <path data-name="Path 986" d="M13.063 65.316h3.266v3.266h-3.266z" />
      <path data-name="Path 987" d="M19.595 65.316h3.266v3.266h-3.266z" />
    </svg>
  )
}

export default SvgComponent
